<div class="wrapper">
  <div class="header">
    <div class="header-content">
      @if (isCreateMode) {
        <div class="create-header">
          <pdq-button variant="light" icon="side_left_arrow" size="large" (onClick)="isCreateMode = false">
          </pdq-button>
          <div class="create-title">Create manifest</div>
        </div>
      } @else {
        <div>Shipping manifests</div>
      }
    </div>
    <pdq-button class="close" icon="close" variant="ghost" [mat-dialog-close]></pdq-button>
  </div>
  @if (isCreateMode) {
    <app-shipping-manifest-create
      [batches]="data.batches"
      [shopMetadata]="data.shopMetadata"
      (completeCreate)="createManifest(false)"></app-shipping-manifest-create>
  } @else {
    <div class="sub-header">
      <div>PDQ will save your manifests for up to 10 days.</div>
      <pdq-button variant="primary" label="Create manifest" (onClick)="createManifest(true)"></pdq-button>
    </div>
    <div class="content">
      @if (!rows?.length) {
        <div class="no-manifests">
          <img src="../../../../assets/icons/search-entire.svg" />
          <div class="text">No recent manifests</div>
        </div>
      } @else {
        <div class="table-wrapper">
          <ngx-datatable
            class="material manifest"
            [rows]="rows"
            [columns]="columns"
            [rowHeight]="68"
            [scrollbarV]="true"
            [virtualization]="true"
            [headerHeight]="46"
            [footerHeight]="0">
            @for (column of columns; track column; let i = $index) {
              <ngx-datatable-column
                [minWidth]="column.minWidth"
                [maxWidth]="column.maxWidth"
                [sortable]="column.sortable"
                name="{{ column.name }}"
                prop="{{ column.prop }}">
                <ng-template ngx-datatable-cell-template let-value="value" let-row="row">
                  @if (column.prop === 'documents') {
                    <pdq-button
                      variant="ghost"
                      icon="dots_menu"
                      matTooltip="Download"
                      (onClick)="downloadManifest(row)"></pdq-button>
                  } @else {
                    <span [ngClass]="{ bold: column.prop === 'displayProvider' }">{{ value }}</span>
                  }
                </ng-template>
              </ngx-datatable-column>
            }
          </ngx-datatable>
        </div>
      }
    </div>
  }
</div>
